import { collection, query, where, orderBy, limit, getDocs, Timestamp, getDoc } from 'firebase/firestore';
import { firestore } from '../firebaseConfig';

const REFS_LIMIT = 20;
const CRAM_WINDOW_MS = 3 * 24 * 60 * 60 * 1000;
const RECENT_UNLOCKS_WINDOW_MS = 7 * 24 * 60 * 60 * 1000;

// --- Ref fetchers (cheap — user docs only, no global resolution) ---

export const fetchCramWordRefs = async (userId) => {
  const cutoff = Timestamp.fromDate(new Date(Date.now() - CRAM_WINDOW_MS));
  const snapshot = await getDocs(
    query(collection(firestore, 'users', userId, 'user_words'), where('last_mistake_at', '>=', cutoff), orderBy('last_mistake_at', 'desc'), limit(REFS_LIMIT))
  );
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const fetchCramSentenceRefs = async (userId) => {
  const cutoff = Timestamp.fromDate(new Date(Date.now() - CRAM_WINDOW_MS));
  const snapshot = await getDocs(
    query(collection(firestore, 'users', userId, 'user_sentences'), where('last_mistake_at', '>=', cutoff), orderBy('last_mistake_at', 'desc'), limit(REFS_LIMIT))
  );
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const fetchRecentUnlocksWordRefs = async (userId) => {
  const cutoff = Timestamp.fromDate(new Date(Date.now() - RECENT_UNLOCKS_WINDOW_MS));
  const snapshot = await getDocs(
    query(
      collection(firestore, 'users', userId, 'user_words'),
      where('learned_at', '>=', cutoff),
      where('skipped', '==', false),
      orderBy('learned_at', 'desc'),
      limit(REFS_LIMIT)
    )
  );
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

export const fetchRecentUnlocksSentenceRefs = async (userId) => {
  const cutoff = Timestamp.fromDate(new Date(Date.now() - RECENT_UNLOCKS_WINDOW_MS));
  const snapshot = await getDocs(
    query(
      collection(firestore, 'users', userId, 'user_sentences'),
      where('learned_at', '>=', cutoff),
      where('skipped', '==', false),
      orderBy('learned_at', 'desc'),
      limit(REFS_LIMIT)
    )
  );
  return snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
};

// --- On-demand resolvers (1 global read per item viewed) ---

export const resolveWordRef = async (userDoc) => {
  if (!userDoc?.word_ref) return null;
  const wordDoc = await getDoc(userDoc.word_ref);
  if (!wordDoc.exists()) return null;
  return { ...userDoc, ...wordDoc.data(), id: userDoc.id };
};

export const resolveSentenceRef = async (userDoc) => {
  if (!userDoc?.sentence_ref) return null;
  const sentenceDoc = await getDoc(userDoc.sentence_ref);
  if (!sentenceDoc.exists()) return null;
  return { ...userDoc, ...sentenceDoc.data(), id: userDoc.id };
};